// import { scrollToTop } from './../utility/helpers'
import { handleRecaptcha } from 'helpers/helpers'
import { message } from 'utility/message'
import validation from 'utility/validation/validation-plugin'

const form = {
  el: {
    root: document.querySelectorAll<HTMLFormElement>('.form'),
    inputs: document.querySelectorAll<HTMLInputElement>('.form [required]'),
    recaptchaError: document.querySelector<HTMLDivElement>('.form .recaptcha-error'),
    message: document.querySelector<HTMLDivElement>('.message'),
  },
  init() {
    if (this.el.root) {
      this.validations()
      this.submit()
      this.shouldResetError()
    }
  },
  shouldResetError() {
    this.el.inputs.forEach((item) => {
      // input + select
      item.addEventListener('blur', (e: Event & { target: HTMLInputElement }) => {
        validation.validate(e.target, e.target, false)
      })

      // Checkbox + radio
      item.addEventListener('change', (e: Event & { target: HTMLInputElement }) => {
        if (e.target.type === 'checkbox' || e.target.type === 'radio') {
          validation.validate(e.target, e.target, false)
        }
      })
    })
  },
  validations() {
    validation.init({ items: this.el.inputs })
  },
  submit() {
    this.el.root.forEach((item) => {
      item.addEventListener('submit', (e) => {
        if (validation.validateForm(this.el.inputs)) {
          handleRecaptcha(e, this.el.recaptchaError)
          message.reset(this.el.message)
        } else {
          e.preventDefault()
          message.show(this.el.message)
        }
      })
    })
  },
}

export default form
